import {getMessages} from 'app/store/constants';

export const MOVE_TO_TEXT = getMessages().getText('board_settings.move_to.text');
export const MOVE_TO_TEXT_EXTRA = getMessages().getText('board_settings.move_to.text.extra');
export const MOVE_TO_BUTTON = getMessages().getText('board_settings.move_to.button');
export const DRIVES_COLUMN_TITLE = getMessages().getText('move_to_drives_column_title');
export const BOARD_BUTTON_MOVE_TO = getMessages().getText('board_details__link_move_to');
